import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';

const initState = {
  editForm: null,
};

function onInitData(state) {
  const editForm = {
    interval: {
      value: 0,
      error: '',
      name: 'interval',
      touched: false,
    },
  };

  return {
    ...state,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onChangeProperty(state, { payload }) {
  const { value } = payload;
  const { editForm } = state;

  editForm.interval = {
    value,
    error: '',
    name: 'interval',
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.INIT_DATA]: onInitData,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOUCH]: onTouch,
});
